import * as React from 'react'

export function ArrowLeft(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 34 29" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M14.654 0L.263 14.391l14.391 14.392 2.474-2.474L6.945 16.16h26.373v-3.534H6.945L17.128 2.44 14.654 0z"
                fill="currentColor"
            />
        </svg>
    )
}
